"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeId = void 0;
class IkeId {
    /**
     * This function is overridden by the browser or node exports
     * with either a browser or node specific random byte generator.
     */
    static getBytes(size) {
        throw new Error('Unable to get Randomness');
    }
    /**
     * Generate a UniqueID based off the Parse ID generator
     * @param length Number of characters to generate
     * @returns {string} Random ID
     */
    static generate(length) {
        const generateLength = length || IkeId.DEFAULT_LENGTH;
        const bytes = IkeId.getBytes(generateLength);
        return IkeId.fromBytes(bytes);
    }
    /**
     * Generate a 16 character long ID that includes 6 bytes of time and 10 bytes of random
     * @param now Timestamp to use, defaults to Date.now()
     * @returns {string} Random Id
     **/
    static generateWithTime(now = Date.now()) {
        return IkeId.fromTime(now) + IkeId.generate();
    }
    static fromBytes(bytes) {
        let randomString = '';
        for (var i = 0; i < bytes.length; i++) {
            randomString += IkeId.CHARS[bytes[i] % IkeId.CHARS.length];
        }
        return randomString;
    }
    /**
     * Encode a time into a ikeId,
     * The resulting id will be within 1 second of the original time and can be reveresed.
     *
     * This will also be able to make sortable ids, eg id:A < id:B
     *
     * This concept is taken from ulid @see https://github.com/ulid/javascript
     *
     * @param now the time to encode
     * */
    static fromTime(now) {
        // Truncate to the second
        now = Math.floor(now / 1000);
        const encodingSize = IkeId.CHARS.length;
        let randomString = '';
        for (let len = IkeId.TIME_LENGTH; len > 0; len--) {
            const byte = now % encodingSize;
            randomString = IkeId.CHARS[byte] + randomString;
            now = (now - byte) / encodingSize;
        }
        return randomString;
    }
    /** Convert a time created id back to the original time */
    static toTime(id) {
        if (id.length !== IkeId.TIME_LENGTH) {
            throw new Error('Invalid id length');
        }
        let output = 0;
        for (let i = IkeId.TIME_LENGTH - 1; i >= 0; i--) {
            const char = id[i];
            const encodingIndex = IkeId.CHARS.indexOf(char);
            output += encodingIndex * Math.pow(IkeId.CHARS.length, IkeId.TIME_LENGTH - i - 1);
        }
        return output * 1000;
    }
    /**
     * Generate a v4 UUID
     * @returns V4 UUID as a string;
     */
    static v4() {
        /* eslint-disable no-bitwise */
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
        return uuid;
    }
}
exports.IkeId = IkeId;
IkeId.TIME_LENGTH = 6;
IkeId.DEFAULT_LENGTH = 10;
IkeId.CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
//# sourceMappingURL=index.js.map